import React from 'react';
export function NotSureSection() {
  return <section className="py-12 lg:py-16 bg-olive" data-id="element-445">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-446">
        <div data-id="element-447">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-448">
            Not Sure Where to Start?
          </h2>
          <p className="text-white/80 text-sm md:text-base font-medium mb-8 max-w-xl mx-auto leading-relaxed" data-id="element-449">
            Book a free 15-minute consultation and we'll discuss which approach
            would be most beneficial for you. No referral required.
          </p>
          <a href="#booking" className="inline-flex items-center justify-center bg-gold hover:bg-gold/90 text-white px-8 py-3.5 rounded-full font-bold text-sm transition-all shadow-lg hover:shadow-xl min-h-[48px] uppercase tracking-wide" data-id="element-450">
            Book a Free Consultation
          </a>
        </div>
      </div>
    </section>;
}